import React, { useState, useEffect } from 'react';
import Layout from './components/Layout/Layout';
import Request from './components/Workspace/Request/RequestPanel';
import Response from './components/Workspace/Response/ResponsePanel';

const App = () => {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState(() => {
    const saved = localStorage.getItem('apiHistory');
    return saved ? JSON.parse(saved) : [];
  });
  const [selectedRequest, setSelectedRequest] = useState(null);

  useEffect(() => {
    localStorage.setItem('apiHistory', JSON.stringify(history));
  }, [history]);

  return (
    <>
      <Layout history={history} setSelectedRequest={setSelectedRequest}>
        <Request
          setResponse={setResponse}
          setLoading={setLoading}
          setHistory={setHistory}
          selectedRequest={selectedRequest}
        />
        <Response response={response} loading={loading} />
      </Layout>
    </>
  );
};

export default App;